import React from "react";

export default function Loading(props) {
    return (
        <>
                {/* {props?.overlay ? ( */}
                    <div id="divLoader" className="loading">
                        <div></div>
                        <div></div>
                    </div>
                {/* ) : (
                    <div id="loading-bar-spinner" className="spinner">
                        <div className="spinner-icon"></div>
                    </div>
                )} */}
        </>
    );
}
